/**
 *
 */
// noinspection ES6UnusedImports
import * as bootstrap from 'bootstrap';

import './app/videos';
import setupOnLoad from './app/on-load';
import setupMainMenu from './app/main-menu';
import setupSlideshows from './app/slideshow';
import setupPhysiciansFilters from './app/physicians-filters';
import setupPhotoGalleries from './app/photo-gallery';
import setupPainAreas from './app/pain-areas';
import setupSiteNotifications from './app/site-notification';
import setupReadMore from './app/read-more';
import { addBootstrapColumnsToWpForm, addBootstrapFormFieldClassesToWpForms } from './app/utils/forms';

//import showScreenInfo from './dev/screen-info';


/**
 *
 */
window.addEventListener('DOMContentLoaded', () => {
	setupOnLoad();
	setupMainMenu();
	setupSlideshows();
	setupPhysiciansFilters();
	setupPhotoGalleries();
	setupPainAreas();
	setupSiteNotifications();
	addBootstrapFormFieldClassesToWpForms();
	setupReadMore();
	addBootstrapColumnsToWpForm(2755, {
		1: 'col col-12 col-md-6',
		2: 'col col-12 col-md-6',
		4: 'col col-12 col-md-6',
		5: 'col col-12 col-md-6',
		6: 'col col-12 col-md-6',
		7: 'col col-12 col-md-6',
	});
	//showScreenInfo(); // todo
});

// Adding the WP Consent header region to the shadow DOM of the WP Consent banner so that we can style it with our theme's CSS.
window.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('#wpconsent-container')) {
		let consentContainer = document.querySelector('#wpconsent-container');
		let consentBannerHeader = consentContainer.shadowRoot.querySelector('.wpconsent-banner-header');
		consentBannerHeader.setAttribute('part', 'wp-consent-banner-header');

		let toggleSwitches = consentContainer.shadowRoot.querySelectorAll('.wpconsent-preferences-checkbox-toggle-slider');
		toggleSwitches.forEach((toggleSwitch) => {
			toggleSwitch.setAttribute('part', 'wp-consent-toggle-switch');
		});

		let checkboxInputs = consentContainer.shadowRoot.querySelectorAll('input[type="checkbox"]');
		checkboxInputs.forEach((checkboxInput) => {
			let checkboxSwitch = checkboxInput.nextElementSibling;
			checkboxInput.addEventListener('click', () => {
				if(checkboxInput.checked) {
					checkboxSwitch.setAttribute('part', 'wp-consent-toggle-switch-checked');
				} else {
					checkboxSwitch.setAttribute('part', 'wp-consent-toggle-switch');
				}
			});
		});
	}
});